import React from 'react';
import FileIcon from '../FileIcon';
import Button from '../Button';
import { ArrowDownCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import Tooltip from '../Tooltip';
import { useTranslation } from '../../lib/intl/hooks/useTranslation';

function FilesList({ children }) {
  return <div className="grid grid-cols-1 gap-x-4 overflow-y-auto w-full rounded">{children}</div>;
}

function FilesListItem({ file, onDownloadFile, isPreview }) {
  const { t } = useTranslation();
  const isDisabled = isPreview;

  // we don't have the translations in the checkout (only in customer portal)
  // so we fall back to an empty string and don't show the tooltip
  const downloadFileLabel = t('customerPortal.files.downloadFile', {
    defaultValue: '',
  });

  return (
    <div
      className={`flex flex-row gap-4 px-2 py-0.5 items-center justify-start border-b border-gray-100`}
    >
      <div className="p-1">
        <FileIcon type={file.type} />
      </div>

      <div className="font-medium truncate">{file.name}</div>

      <div className="ml-auto">
        <Button
          onClick={onDownloadFile}
          className={clsx('text-[var(--color-primary)] !px-1.5 !py-1.5', {
            'hover:text-[var(--color-primary-dark)]': !isDisabled,
          })}
          aria-label={downloadFileLabel}
          disabled={isDisabled}
        >
          {downloadFileLabel ? (
            <Tooltip label={downloadFileLabel}>
              <ArrowDownCircleIcon className="h-7 w-7" />
            </Tooltip>
          ) : (
            <ArrowDownCircleIcon className="h-7 w-7" />
          )}
        </Button>
      </div>
    </div>
  );
}

FilesList.List = FilesList;
FilesList.Item = FilesListItem;

export default FilesList;
